import * as yup from "yup";
import { getNoteSchema } from "@/services/api";

export const getNoteEditorSchema = () =>
  yup.object().shape({
    currentNote: getNoteSchema(),
  });
